<template>
  <el-dialog :title="title"
             :visible.sync="visible"
             width="660px"
             append-to-body=""
             @closed='handleClose'
             :close-on-press-escape="false">
    <el-form :model="certificate"
             label-position="left"
             :rules="rules"
             ref="ruleForm"
             label-width="85px">
      <el-form-item v-if="certificate.regulatorId || certificate.vendorId"
                    label="证书名称:"
                    prop="certName">
        <el-input v-model.number="certificate.certName"></el-input>
      </el-form-item>
      <el-form-item v-else
                    label="证书名称:">
        <span>{{ certificate.certName }}</span>
      </el-form-item>
      <el-form-item v-if="certificate.regulatorId"
                    prop="vendorId"
                    label="选择企业:">
        <span v-if=" certificate.vendorName ">{{ certificate.vendorName }}</span>
        <span v-else>请选择</span>
        <i style="cursor: pointer;margin-left: 10px"
           class="el-icon-edit"
           @click="selectEnt"></i>
      </el-form-item>
      <el-form-item label="有效期:"
                    prop="time">
        <el-date-picker
                        v-model="certificate.time"
                        type="daterange"
                        unlink-panels
                        range-separator=""
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="证书文件:"
                    prop="certFile">
        <custom-upload-file v-model="certificate.certFile"
                            @update:loading="handleLoading"
                            :limit="5"
                            rolate
                            accept="image/*,.pdf" />
      </el-form-item>
    </el-form>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="visible = false"
                 :loading="loading">取 消</el-button>
      <el-button type="primary"
                 @click="handleSubmit"
                 :loading="loading">确 定</el-button>
    </span>
    <org-select-ent-modal ref="ent" :callback="entCallback" />
  </el-dialog>
</template>
<script>
import CustomUploadFile from '@/components/public/custom-upload-file.vue'
import { mapState } from 'vuex'
import OrgSelectEntModal from './busi/org-select-ent-modal.vue'
export default {
  name: 'certificate-modal',
  components: { CustomUploadFile, OrgSelectEntModal },
  props: {
    fetch: { type: Function, required: true }
  },
  data () {
    return {
      loading: false,
      visible: false,
      certificate: {
        regulatorId: null, vendorId: null, vendorName: '', certFileId: null, certId: null, certName: '', time: '', certFile: []
      },
      rules: {
        certName: [{ required: true, message: '请输入证书名称', trigger: 'blur' }],
        time: [
          { required: true, message: '请选择有效期', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (Array.isArray(value) && value[1].getTime() < Date.now()) {
                callback(new Error('有效期的结束时间必须大于今天'))
              }
              callback()
            },
            trigger: 'blur'
          }
        ],
        vendorId: [{ required: true, message: '请选择企业', trigger: 'change' }],
        certFile: [{ required: true, message: '请上传证书文件', trigger: 'change' }]
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo
    }),
    title ({ certificate }) {
      const { regulatorId, vendorId, certFileId } = certificate
      return (regulatorId || vendorId) ? '新建证书' : (certFileId ? '修改证书文件' : '新建证书文件')
    }
  },
  methods: {
    init (row = {}) {
      this.certificate = { ...this.certificate, ...row }
      this.visible = true
    },
    selectEnt () {
      this.$refs.ent.fetch()
    },
    entCallback (row) {
      this.certificate.vendorId = row.vendorId
      this.certificate.vendorName = row.vendorName
      this.$refs.ruleForm.validateField('vendorId')
    },
    handleClose () {
      this.$refs.ruleForm.resetFields()
      this.certificate = {
        ...this.certificate, regulatorId: null, vendorId: null, vendorName: '', certFileId: null, certId: null, certName: '', time: '', certFile: []
      }
    },
    handleLoading (loading) {
      this.loading = loading
    },
    handleSubmit () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          const { regulatorId, vendorId, certFileId } = this.certificate
          if (regulatorId || vendorId) {
            this.addcertificate()
          } else if (certFileId) {
            this.updatecertificatefile()
          } else {
            this.addcertificatefile()
          }
        }
      })
    },
    addcertificate () {
      const { time, certFile } = this.certificate
      this.$store.dispatch('certificate/addcertificate', {
        payload: {
          certLevel: 1,
          ...this.certificate,
          certBeginTime: +time[0],
          certEndTime: +time[1],
          certFile: certFile.map(item => item.url).join(',')
        },
        success: (res) => {
          this.loading = false
          this.visible = false
          this.fetch && this.fetch()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    updatecertificatefile () {
      const { time, certFile } = this.certificate
      this.$store.dispatch('certificate/updatecertificatefile', {
        payload: {
          ...this.certificate,
          certBeginTime: +time[0],
          certEndTime: +time[1],
          certFile: certFile.map(item => item.url).join(',')
        },
        success: (res) => {
          this.loading = false
          this.visible = false
          this.fetch && this.fetch()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    addcertificatefile () {
      const { time, certFile } = this.certificate
      this.$store.dispatch('certificate/addcertificatefile', {
        payload: {
          ...this.certificate,
          certBeginTime: +time[0],
          certEndTime: +time[1],
          certFile: certFile.map(item => item.url).join(',')
        },
        success: (res) => {
          this.loading = false
          this.visible = false
          this.fetch && this.fetch()
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
